var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.props.open)?_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"container-form",style:(_vm.props.styles)},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }